import { render, staticRenderFns } from "./notice_page.vue?vue&type=template&id=07d5c995&scoped=true"
import script from "./notice_page.vue?vue&type=script&setup=true&lang=js"
export * from "./notice_page.vue?vue&type=script&setup=true&lang=js"
import style0 from "./notice_page.vue?vue&type=style&index=0&id=07d5c995&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07d5c995",
  null
  
)

export default component.exports